import Navigation from './Navigation.js';

export default function Header({ handlePageChange }) {
  return (
    <div className='App'>
      {/* Can probably delete className='App' */}

      <nav className='nav-extended color-primary '>
        <div className='container'>
          <div className='nav-wrapper'>
            <a
              href='#about'
              onClick={() => handlePageChange('About')}
              className='brand-logo'
              style={{
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontSize: 'clamp(1.2rem, 4vw, 2.1rem)',
              }}
            >
              Christopher DuBois
            </a>
          </div>
          <div className='nav-content'>
            <Navigation handlePageChange={handlePageChange} />
          </div>
        </div>
      </nav>
    </div>
  );
}
